import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./EventSlot.css";
import vector from "../../../../../../assets/images/meetupEvent/Vector.png";
import axios from "axios";
import { Markup } from "interweave";
import moment from "moment";
import swal from "sweetalert";
import { serverInfo } from "../../../../../../App";
import { useContext } from "react";
import flag from "../../../../../../assets/images/Auditions/flag.png";
import flag4 from "../../../../../../assets/images/Interval-01.1.png";
import flag2 from "../../../../../../assets/images/Maximum-Time-01.1.png";
import flag3 from "../../../../../../assets/images/Minimum-Time-01.1.png";
import ScreenRecordShow from "../../../../../Reuseable/ScreenRecordShow";
import Countdown from "react-countdown";
import ContdownTimerRender from "../../../../../../HelperComponent/ContdownTimerRender";

const toInputTime = (timeValue) => {
  if (!timeValue) {
    return "";
  }

  const parsedTime = moment(timeValue, ["HH:mm:ss", "HH:mm"], true);
  return parsedTime.isValid() ? parsedTime.format("HH:mm") : "";
};

const toEventDateTimeMoment = (eventDate, eventTime) =>
  moment(
    `${eventDate || ""} ${eventTime || ""}`,
    ["YYYY-MM-DD HH:mm:ss", "YYYY-MM-DD HH:mm"],
    true
  );

const EventSlot = (props) => {
  const { imageCdnUrl } = useContext(serverInfo);

  const [event, setEvent] = useState("");
  const [slot, setSlot] = useState([]);
  const [count, setCount] = useState("");
  const [callJoinBuffer, setCallJoinBuffer] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editLoading, setEditLoading] = useState(false);
  const [editErrors, setEditErrors] = useState({});
  const [editForm, setEditForm] = useState({
    start_time: "",
    end_time: "",
    total_seat: "",
  });
  const authName = localStorage.getItem("auth_name");

  useEffect(() => {
    const event_slug = props.match.params.slug;

    axios.get(`/api/admin/meetup_event/details/${event_slug}`).then((res) => {
      if (res.data.status === 200) {
        setEvent(res.data.meetup);
      }
    });

    axios.get(`/api/admin/meetup_event_slots/${event_slug}`).then((res) => {
      if (res.data.status === 200) {
        setSlot(res.data.meetup);
        setCount(res.data.count);
      }
    });
  }, [props.match.params.slug]);

  const joinRoute = (room_id) => {
    // alert()
    setCallJoinBuffer(true);
    axios
      .get("/sanctum/csrf-cookie")
      .then((response) => {
        axios.get(`/api/sdk/get-token/admin`).then((res) => {
          // alert(res.data.token)
          setCallJoinBuffer(false);
          window.open(
            `/video-meeting?token=${res.data.token}&meetingId=${room_id}&webcamEnabled=true&micEnabled=true&name=${authName}&whiteboardEnabled=true&canDrawOnWhiteboard=true&canToggleWhiteboard=true&canChangeLayout=true&canPin=true&askJoin=false&participantCanToggleOtherMic=true&participantCanToggleOtherWebcam=true&canRemoveOtherParticipant=true`
          );
        });
      })
      .catch((err) => {
        alert("network problem");
      });
  };

  const openEditModal = () => {
    if (!canEditBeforeStart) {
      swal("Event Started", "You can edit these fields only before event start.", "warning");
      return;
    }

    setEditForm({
      start_time: toInputTime(event.start_time),
      end_time: toInputTime(event.end_time),
      total_seat: event.total_seat || "",
    });
    setEditErrors({});
    setIsEditModalOpen(true);
  };

  const closeEditModal = () => {
    if (editLoading) {
      return;
    }

    setEditErrors({});
    setIsEditModalOpen(false);
  };

  const handleEditInput = (e) => {
    const { name, value } = e.target;
    setEditForm((prev) => ({ ...prev, [name]: value }));

    if (editErrors[name]) {
      setEditErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const submitEventQuickEdit = (e) => {
    e.preventDefault();

    if (!canEditBeforeStart) {
      swal("Event Started", "You can edit these fields only before event start.", "warning");
      setIsEditModalOpen(false);
      return;
    }

    const validationErrors = {};
    if (!editForm.start_time) {
      validationErrors.start_time = "Event start time is required.";
    }
    if (!editForm.end_time) {
      validationErrors.end_time = "Event end time is required.";
    }
    if (
      !editForm.total_seat ||
      Number(editForm.total_seat) <= 0 ||
      !Number.isInteger(Number(editForm.total_seat))
    ) {
      validationErrors.total_seat = "Total seat must be a positive whole number.";
    }

    const newStartMoment = toEventDateTimeMoment(event.event_date, editForm.start_time);
    const newEndMoment = toEventDateTimeMoment(event.event_date, editForm.end_time);
    if (newStartMoment.isValid() && newEndMoment.isValid() && !newEndMoment.isAfter(newStartMoment)) {
      validationErrors.end_time = "Event end time must be after event start time.";
    }

    if (Object.keys(validationErrors).length > 0) {
      setEditErrors(validationErrors);
      return;
    }

    setEditLoading(true);
    setEditErrors({});

    const fData = new FormData();
    fData.append("banner", event.banner || "");
    fData.append("title", event.title || "");
    fData.append("meetup_type", event.meetup_type || "");
    fData.append("event_date", event.event_date || "");
    fData.append("start_time", editForm.start_time);
    fData.append("end_time", editForm.end_time);
    fData.append("description", event.description || "");
    fData.append("instruction", event.instruction || "");
    fData.append("venue", event.venue || "");
    fData.append("total_seat", editForm.total_seat);
    fData.append("reg_start_date", event.reg_start_date || "");
    fData.append("reg_end_date", event.reg_end_date || "");
    fData.append("fee", event.fee || "");

    axios
      .get("/sanctum/csrf-cookie")
      .then(() => axios.post(`/api/admin/edit_meetup/${event.id}`, fData))
      .then((res) => {
        if (res.data.status === 200) {
          const updatedMeetup = res.data.meetup || {
            ...event,
            start_time: editForm.start_time,
            end_time: editForm.end_time,
            total_seat: editForm.total_seat,
          };

          setEvent(updatedMeetup);
          setIsEditModalOpen(false);
          swal("Success", res.data.message || "Meetup updated successfully.", "success");
        } else {
          setEditErrors(res.data.validation_errors || {});
          if (!res.data.validation_errors) {
            swal("Error", res.data.message || "Unable to update meetup.", "error");
          }
        }
      })
      .catch(() => {
        swal("Error", "Something went wrong while updating the meetup.", "error");
      })
      .finally(() => {
        setEditLoading(false);
      });
  };

  const eventStartMoment = toEventDateTimeMoment(event.event_date, event.start_time);
  const eventEndMoment = toEventDateTimeMoment(event.event_date, event.end_time);
  const canEditBeforeStart = eventStartMoment.isValid() && moment().isBefore(eventStartMoment);
  const isEventLiveNow =
    Number(event.status) === 2 &&
    eventStartMoment.isValid() &&
    eventEndMoment.isValid() &&
    moment().isBetween(eventStartMoment, eventEndMoment, null, "[]");

  const countdownDate = eventStartMoment.isValid()
    ? eventStartMoment.toDate()
    : moment().add(1, "minute").toDate();

  return (
    <div className="container-fluid">
      <>
        <div className="row">
          <div className="col-md-6 mb-3">
            <div className="card card-bg p-2">
              <img
                src={imageCdnUrl + event.banner}
                alt=""
                className="Banner-SME-b"
              />

              <Countdown
                date={countdownDate}
                renderer={ContdownTimerRender}
              />
            </div>
          </div>
          <div className="col-sm-12 col-md-12 col-lg-6 m-0 mb-3">
            <div className="registration-head  card-bg mb-1">
              <div className="d-flex justify-content-between align-items-center p-2">
                <h5 className="text-warning fw-bold m-0">Registration </h5>
                <button
                  type="button"
                  className="btn registration-edit-btn"
                  onClick={openEditModal}
                  disabled={!canEditBeforeStart}
                  title={
                    canEditBeforeStart
                      ? "Edit event start, end and total seat"
                      : "You can edit only before event start"
                  }
                >
                  <i className="fas fa-edit"></i>
                </button>
              </div>
            </div>

            <div className="row registration-body  card-bg m-0 pt-3">
              <div className="col-md-6 m-0 ">
                <div className="d-flex registration-btn p-2">
                  <div className="mx-3 mt-2">
                    <span className="text-light">
                      <img src={flag} alt="" className="PriceTage" />
                    </span>
                  </div>
                  <div className=" mx-1">
                    <span className="text-light">Registration Start:</span>
                    <br></br>
                    <span className=" text-warning fw-bold">
                      {moment(event.reg_start_date).format("LL")}
                    </span>
                  </div>
                </div>
              </div>

              <div className="col-md-6 m-0 ">
                <div className="d-flex registration-btn p-2">
                  <div className="mx-3 mt-2">
                    <span className="text-light">
                      <img src={flag} alt="" className="PriceTage" />
                    </span>
                  </div>
                  <div className=" mx-1">
                    <span className="text-light">Registration End:</span>
                    <br></br>
                    <span className=" text-warning fw-bold">
                      {moment(event.reg_end_date).format("LL")}
                    </span>
                  </div>
                </div>
              </div>

              <div className="col-md-6 m-0 ">
                <div className="d-flex registration-btn p-2">
                  <div className="mx-3 mt-2">
                    <span className="text-light">
                      <img src={flag2} alt="" className="PriceTage" />
                    </span>
                  </div>
                  <div className=" mx-1">
                    <span className="text-light">Type:</span>
                    <br></br>
                    <span className=" text-warning fw-bold">
                      {event.meetup_type}
                    </span>
                  </div>
                </div>
              </div>

              <div className="col-md-6 m-0 ">
                <div className="d-flex registration-btn p-2">
                  <div className="mx-3 mt-2">
                    <span className="text-light">
                      <img src={flag3} alt="" className="PriceTage" />
                    </span>
                  </div>
                  <div className=" mx-1">
                    <span className="text-light">Total Seat: </span>
                    <br></br>
                    <span className=" text-warning fw-bold">
                      {event.total_seat}
                    </span>
                  </div>
                </div>
              </div>

              <div className="col-md-6 m-0 ">
                <div className="d-flex registration-btn p-2">
                  <div className="mx-3 mt-2">
                    <span className="text-light">
                      <img src={flag} alt="" className="PriceTage" />
                    </span>
                  </div>
                  <div className=" mx-1">
                    <span className="text-light">Event Start:</span>
                    <br></br>
                    <span className=" text-warning fw-bold">
                      {moment(event.event_date).format("LL")} |{" "}
                      {moment(event.start_time, "HH:mm:ss").format("hh:mm A")}
                    </span>
                  </div>
                </div>
              </div>

              <div className="col-md-6 m-0 ">
                <div className="d-flex registration-btn p-2">
                  <div className="mx-3 mt-2">
                    <span className="text-light">
                      <img src={flag} alt="" className="PriceTage" />
                    </span>
                  </div>
                  <div className=" mx-1">
                    <span className="text-light">Event End:</span>
                    <br></br>
                    <span className=" text-warning fw-bold">
                      {moment(event.event_date).format("LL")} |{" "}
                      {moment(event.end_time, "HH:mm:ss").format("hh:mm A")}
                    </span>
                  </div>
                </div>
              </div>

              {event.meetup_type === "Offline" ? (
                <div className="col-md-12 m-0 ">
                  <div className="d-flex registration-btn p-2">
                    <div className="mx-3 mt-2">
                      <span className="text-light">
                        <img src={flag4} alt="" className="PriceTage" />
                      </span>
                    </div>
                    <div className=" mx-1">
                      <span className="text-light">Venue: </span>
                      <br></br>
                      <span className=" text-warning fw-bold">
                        {event.venue}
                      </span>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </>

      <div className="row mt-1">
        <div className="col-md-12">
          <div className="card card-bg shadow">
            <div className="card-body">
              <h5 className="text-light pb-3">
                {event.title} &nbsp;
                <span className="text-warning"> ({event.meetup_type})</span>
              </h5>

              <h5 className="text-warning">Instruction</h5>
              <div className="under-line"></div>
              <p className="text-light mt-2">
                <Markup content={event.instruction} />
              </p>

              <h5 className="text-warning">Description</h5>
              <div className="under-line"></div>
              <p className="text-light mt-2">
                <Markup content={event.description} />
              </p>

              <div className="col-md-4 card card-bg-event head-line my-2 mt-4 row justify-content-between mx-0">
                <h5 className="text-warning pt-2 ">Event Date</h5>
                <p className="text-light fw-bold pt-2">
                  {moment(event.event_date).format("LL")} |{" "}
                  {moment(event.start_time, "HH:mm:ss").format("hh:mm A")}-
                  {moment(event.end_time, "HH:mm:ss").format("hh:mm A")}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row my-3">
        {event.meetup_type === "Online" ? (
          <ScreenRecordShow roomId={event.event_link} />
        ) : (
          <></>
        )}

        <div className="col-md-12">
          <div className="card card-bg solt-card">
            <div className="card-body">
              <h3 className="text-warning">
                <img src={vector} alt="clock" className="mx-2"></img>
                Slots{" "}
                <sub>
                  ({count}/{event.total_seat})
                </sub>
              </h3>
              <div className="row my-3">
                {slot.map((user, index) => (
                  <div className="col-md-2 col-sm-3 " key={user?.id || `${user?.user?.id || "slot"}-${index}`}>
                    <p className="sold-small-card fw-bold">
                      <img
                        src={imageCdnUrl + user.user?.image}
                        className="img-fluid mx-2 p-1"
                        alt=""
                        style={{
                          height: "50px",
                          width: "50px",
                          borderRadius: "50%",
                        }}
                      />
                      {user.user?.first_name} {user.user?.last_name}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {isEventLiveNow ? (
        
          <div className="mt-3 d-flex justify-content-center">

          {event.meetup_type === "Offline" ? null : (
            <button
              className="btn btnJoinNow MEN-X fw-bold px-5"
              onClick={() => joinRoute(event.event_link)}
            >
              {callJoinBuffer && (
                <div
                className="spinner-border text-warning"
                  role="status"
                  style={{ height: "20px", width: "20px", marginRight: "10px" }}
                >
                  <span className="sr-only">Loading...</span>
                </div>
              )}
              Join Now
            </button>
          )}
          </div>
        ) : Number(event.status) < 1 ? (
          <div className="mt-3 d-flex justify-content-center">
            <Link to={`/superstar-admin/live-chat/edit/${event.id}`}>
              {" "}
              <button className="btn btn-info mt-2 px-5">Edit</button>
            </Link>
          </div>
        ) : Number(event.status) === 9 ? (
          <></>
        ) : (
          <>
          {" "}
            {event.meetup_type === "Offline" ? null : (
            <div className="mt-3 d-flex justify-content-center">
              <button className="btn btnJoinNow MEN-X fw-bold px-5" disabled>
                Join Now
              </button>
            </div>
            )}
          </>
        )}

        {isEditModalOpen && (
          <div className="event-edit-modal-backdrop" onClick={closeEditModal}>
            <div className="event-edit-modal card card-bg" onClick={(e) => e.stopPropagation()}>
              <div className="event-edit-modal-header">
                <h5 className="text-warning fw-bold m-0">Update Event Details</h5>
                <button
                  type="button"
                  className="btn text-light"
                  onClick={closeEditModal}
                  disabled={editLoading}
                >
                  <i className="fas fa-times"></i>
                </button>
              </div>

              <form onSubmit={submitEventQuickEdit}>
                <div className="event-edit-modal-body">
                  <div className="mb-3">
                    <label className="form-label text-light">Event Start Time</label>
                    <input
                      type="time"
                      className="form-control reply-control"
                      name="start_time"
                      value={editForm.start_time}
                      onChange={handleEditInput}
                      required
                    />
                    {editErrors?.start_time && (
                      <small className="text-danger">{editErrors.start_time}</small>
                    )}
                  </div>

                  <div className="mb-3">
                    <label className="form-label text-light">Event End Time</label>
                    <input
                      type="time"
                      className="form-control reply-control"
                      name="end_time"
                      value={editForm.end_time}
                      onChange={handleEditInput}
                      required
                    />
                    {editErrors?.end_time && (
                      <small className="text-danger">{editErrors.end_time}</small>
                    )}
                  </div>

                  <div className="mb-2">
                    <label className="form-label text-light">Total Seat</label>
                    <input
                      type="number"
                      min="1"
                      step="1"
                      className="form-control reply-control"
                      name="total_seat"
                      value={editForm.total_seat}
                      onChange={handleEditInput}
                      required
                    />
                    {editErrors?.total_seat && (
                      <small className="text-danger">{editErrors.total_seat}</small>
                    )}
                  </div>
                </div>

                <div className="event-edit-modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={closeEditModal}
                    disabled={editLoading}
                  >
                    Cancel
                  </button>
                  <button type="submit" className="btn btnUpdate fw-bold" disabled={editLoading}>
                    {editLoading ? (
                      <span>
                        <i className="fas fa-spinner fa-pulse me-1"></i>
                        Updating...
                      </span>
                    ) : (
                      "Update"
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default EventSlot;
